module.exports = __webpack_public_path__ + "static/media/Roboto-Regular.303c6d9e.ttf";